import { createReducer } from './create';

const initialState = {
    stock_check_enabled: true,
};

export default createReducer(initialState, {
    ['APP/CLEAR']: () => {
        return initialState;
    },
    ['APP/SOFT_CLEAR']: () => {
        return initialState;
    },
    ['APP/DISABLE_STOCK_CHECK']: (state, payload) => {
        return Object.assign({}, state, {
            stock_check_enabled: false,
        });
    },
    ['APP/ENABLE_STOCK_CHECK']: (state, payload) => {
        return Object.assign({}, state, {
            stock_check_enabled: true,
        });
    },
});
